import React, {useContext} from "react";
import "./GreenTarifConfirmDialog.scss";
import {Dialog} from "@material-ui/core";
import walletImage from "../../../../images/wallet.svg"
import {ReactSVG} from "react-svg";
import {Button} from "../../../../components/Button";
import {strings} from "../../../../strings/strings";
import {premiumFormat} from "../../../../utils/format";

interface GreenTarifConfirmDialogProps {
    amount: number;
    open: boolean;
    onClose: (event: any) => void;
    toNextStepListener: () => void;
    editParametersListener: () => void;
}

export const GreenTarifConfirmDialog = (props: GreenTarifConfirmDialogProps) => {
    const {open, onClose, amount, toNextStepListener, editParametersListener} = props;

    return (
        <Dialog open={open} onClose={onClose} disableBackdropClick={true}>
            <div className={"vs-dialog vs-dialog_green-tarif-confirm"}>
                <div className={"vs-dialog__content fluid"}>
                    <div className={"vs-dialog__content__icon"}>
                        <ReactSVG src={walletImage}/>
                    </div>

                    <div className={"vs-dialog__content__title"}>
                        <div className={"vs-dialog__content__title__label"}>{strings.greenTarifConfirmDialog.title}</div>
                        <div className={"vs-dialog__content__title__amount"}>{premiumFormat(amount)} {strings.currencyUAH}</div>
                    </div>


                    <div className={"vs-dialog__content__controls"}>
                        <Button id={'green-confirm-tarif__next-Step'}
                                label={strings.stepsNext}
                                onClickListener={toNextStepListener}/>
                        <Button id={'green-confirm-tarif__edit-parameters'}
                                variant='notSelected'
                                label={strings.greenTarifConfirmDialog.changeParameters}
                                onClickListener={editParametersListener}/>
                    </div>
                </div>
            </div>
        </Dialog>
    )
};